import React from 'react';
import { useTranslation } from 'react-i18next';

const PrivacyPage = () => {
    const { t } = useTranslation();

    return (
        <div className="max-w-3xl mx-auto py-10 px-4">
            <h1 className="text-2xl font-bold mb-6">{t('privacyTitle')}</h1>

            <p className="mb-4">{t('privacyIntro')}</p>

            <ul className="list-disc pl-5 space-y-2 mb-6">
                <li>{t('privacyItem1')}</li>
                <li>{t('privacyItem2')}</li>
                <li>{t('privacyItem3')}</li>
            </ul>

            <p className="text-sm text-gray-600">{t('lastUpdated')}</p>
        </div>
    );
};

export default PrivacyPage;
